import { Controller } from '@hotwired/stimulus';

// The refusal's lines (f.errors, docs/DESIGN.md § CRUD): each is a link to the
// box it refuses, but the builder can only guess the box from the attribute.
// One the page never drew (a derived key, a field the host left out) would be
// a link to nowhere, so it becomes plain text here. Following a live one
// focuses the control: a fragment alone only scrolls to it. A box a controller
// hides (the multiselect's select, the editor's textarea) hands the focus to
// the field's first one she can see.
//
//   <div role="alert" data-controller="error-links">
export default class extends Controller {
  connect() {
    this.element.querySelectorAll('a[href^="#"]').forEach((link) => {
      if (!this.boxOf(link)) link.replaceWith(link.textContent);
    });
  }

  follow(event) {
    const link = event.target.closest('a[href^="#"]');
    const box = link && this.seen(this.boxOf(link));
    if (!box) return;

    event.preventDefault();
    box.focus({ preventScroll: true });
    box.scrollIntoView({ block: 'center' });
  }

  // The raw href, not link.hash: that one comes back percent-encoded, and a
  // host's id may hold a "ç".
  boxOf(link) {
    return document.getElementById(link.getAttribute('href').slice(1));
  }

  seen(box) {
    if (!box || box.checkVisibility()) return box;

    const controls = box.closest('fieldset')?.querySelectorAll(
      'input:not([type=hidden]), select, textarea, [contenteditable=true]',
    );
    return [...(controls ?? [])].find((control) => control.checkVisibility());
  }
}
